import {createSelector} from 'reselect';

const selectAuth = (state) => state.auth;

const selectSpiceToken = createSelector(selectAuth, (authState) => authState.spiceToken);

const selectAuthUsername = createSelector(selectAuth, (authState) => authState.username);

const selectAccessToken = createSelector(selectAuth, (authState) => authState.accessToken);

const selectAccessTokenData = createSelector(
    selectAuth,
    ({accessToken, expirationDate, isAnonymous, isRequestFailed}) => ({
        accessToken,
        expirationDate,
        isAnonymous,
        isRequestFailed,
    })
);

const selectRefreshToken = createSelector(selectAuth, (authState) => authState.refreshToken);

const selectUamAuthToken = createSelector(selectAuth, (authState) => authState.uamAuthToken);

const selectHolderUamAuthToken = createSelector(selectAuth, (authState) => authState.holderUamAuthToken);

const selectUamApiKey = createSelector(selectAuth, (authState) => authState.uamApiKey);

const selectUamApiUrl = createSelector(selectAuth, (authState) => authState.uamApiUrl);

const selectGamAuthToken = createSelector(selectAuth, (authState) => authState.gamAuthToken);

const selectHolderGamAuthToken = createSelector(selectAuth, (authState) => authState.holderGamAuthToken);

const selectIsFetchTokenInProgress = createSelector(selectAuth, (authState) => authState.isFetchTokenInProgress);

export {
    selectAccessToken,
    selectAccessTokenData,
    selectAuthUsername,
    selectGamAuthToken,
    selectHolderGamAuthToken,
    selectHolderUamAuthToken,
    selectIsFetchTokenInProgress,
    selectRefreshToken,
    selectSpiceToken,
    selectUamApiKey,
    selectUamApiUrl,
    selectUamAuthToken,
};
